/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-400) var(--nve-ref-size-500) var(--nve-ref-size-500);
  width: 100%; /* fallback safari */
  width: stretch;
}

[internal-host] {
  display: flex;
  flex-direction: column;
}

:host([container='flat']) [internal-host] {
  gap: var(--nve-ref-space-xxxs);
}

:host([container='inset']) [internal-host] {
  gap: var(--nve-ref-space-md);
}

:host(:not([container])) ::slotted(nve-accordion:not(:last-child)) {
  border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
}

:host([container='full']) ::slotted(nve-accordion:not(:last-child)) {
  border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
}
